import { Paragraph, TextArea, XStack, YStack } from 'tamagui';
import { MAX_MESSAGE_LENGTH } from '../../lib/chat-view';
import { FocusRingButton } from '../FocusRingButton';

const SEND_TAP_TARGET = 44;

interface ChatComposerProps {
  value: string;
  onChange: (text: string) => void;
  onSend: () => void;
  disabled: boolean;
  canSend: boolean;
  exhausted: boolean;
  errorMessage: string | null;
}

/** Textarea + live counter + Send. The parent owns send-eligibility via `canSend`. */
export function ChatComposer({
  value,
  onChange,
  onSend,
  disabled,
  canSend,
  exhausted,
  errorMessage,
}: ChatComposerProps) {
  const over = value.length > MAX_MESSAGE_LENGTH;
  return (
    <YStack gap="$2" width="100%">
      {exhausted ? (
        <Paragraph color="$orange10">Daily limit reached — resets tomorrow.</Paragraph>
      ) : null}
      {errorMessage ? <Paragraph color="$red10">{errorMessage}</Paragraph> : null}
      <TextArea
        id="chat-composer"
        value={value}
        onChangeText={onChange}
        placeholder="Ask about this vehicle…"
        minHeight={80}
        disabled={disabled}
      />
      <XStack justifyContent="space-between" alignItems="center" gap="$2">
        <Paragraph size="$1" color={over ? '$red10' : '$color10'}>
          {`${value.length}/${MAX_MESSAGE_LENGTH}`}
        </Paragraph>
        <FocusRingButton
          theme="blue"
          minHeight={SEND_TAP_TARGET}
          minWidth={SEND_TAP_TARGET}
          disabled={!canSend}
          onPress={onSend}
        >
          Send
        </FocusRingButton>
      </XStack>
    </YStack>
  );
}
